import { NhostClient } from '@nhost/nhost-js'

export const nhost = new NhostClient({
   backendUrl: 'https://amsstagingapis.centa.org',
  // backendUrl: 'https://amsapis.centa.org',
  // backendUrl: 'https://frqvtslpzvofvcebcvql.nhost.run',
})
